module.exports = "/desktop-app/assets/img/shut.svg?19a5d48b932e48b6bd197ff5858d912d";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/svg/shut.svg
// module id = OHyJ
// module chunks = 1